import React from 'react'

import { IContestPrize } from 'protos'

import Currency from 'components/Currency'

interface EventPrizeProps {
  prize?: IContestPrize
  prizes?: IContestPrize[]
}

const EventPrize: React.SFC<EventPrizeProps> = ({ prize, prizes }) => {
  if (prizes) {
    return (
      <>
        {
          prizes
            .map((rawPrize, i) => <EventPrize prize={rawPrize} key={`prize-${i}`} />)
            .map((node, i) => i > 0 ? [', ', node] : node)
        }
      </>
    )
  }

  if (prize) {
    if (prize.money) {
      return <Currency {...prize.money} />
    }
    if (prize.product) {
      if ((prize.product.quantity || 1) > 1) {
        return <span>{`${prize.product.quantity} x ${prize.product.title}`}</span>
      }
      return <span>{prize.product.title}</span>
    }
  }

  return null
}

export default EventPrize
